import { render, staticRenderFns } from "./b41.vue?vue&type=template&id=38ad8c93&scoped=true"
import script from "./b41.vue?vue&type=script&lang=js"
export * from "./b41.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad8c93",
  null
  
)

export default component.exports